import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { fonts } = theme;

export const price = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const previous = css`
  color: var(--neutral-black-70);
  text-decoration: line-through;
`;

export const sale = css`
  color: var(--functional-red-base);
`;
